import { useEffect, useState } from "react";
import { onAuthStateChanged } from "firebase/auth";
import { get, ref } from "firebase/database";
import { Navigate } from "react-router-dom";
import { auth, db } from "../services/firebase";

export default function AdminProtectedRoute({ children }) {
    const [accessState, setAccessState] = useState({
        checking: true,
        user: null,
        isAdmin: false,
    });

    useEffect(() => {
        const unsubscribe = onAuthStateChanged(auth, async (user) => {
            if (!user) {
                setAccessState({ checking: false, user: null, isAdmin: false });
                return;
            }

            try {
                const adminSnapshot = await get(ref(db, `Admin/${user.uid}`));

                setAccessState({
                    checking: false,
                    user,
                    isAdmin: adminSnapshot.exists(),
                });
            } catch (error) {
                console.error("Admin access check failed", error);
                setAccessState({ checking: false, user, isAdmin: false });
            }
        });

        return () => unsubscribe();
    }, []);

    if (accessState.checking) return <p>Loading...</p>;

    if (!accessState.user) return <Navigate to="/" replace />;

    if (!accessState.isAdmin) return <Navigate to="/user/packs" replace />;

    return children;
}
